import { useState, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../components/utils/Icons/CustomIcons"
import {
  clearQrId,
  copyEvent,
  getEvent,
  getEventByHash,
} from "../../redux/slices/events/eventsSlice"
import {
  deleteGuest,
  getContactsOnEvent,
  setLoading,
} from "@/redux/slices/contacts/contactsSlices"
import { getBalance } from "@/redux/slices/balance/balanceSlice"
import api from "@/api/api"
import { Image, Button } from "react-bootstrap"
import { t } from "i18next"
import { MdEdit, MdOutlineGrading } from "react-icons/md"
import { ToastContainer, toast, Slide } from "react-toastify"
import { useAppDispatch, useAppSelector } from "@/redux/store"
import { useTranslation } from "react-i18next"
import weddingImage from "@/assets/images/weddingImage.png"
import { RiDeleteBin6Line } from "react-icons/ri"
import { MdLocalPhone } from "react-icons/md"
import { BiSave } from "react-icons/bi"
import { IoMdAdd } from "react-icons/io"
import { IoChevronBack } from "react-icons/io5"
import { LuDownload } from "react-icons/lu"
import { IoMdCheckmark } from "react-icons/io"

import Modal from "react-bootstrap/Modal"
import ResponsiveImageWithQRCode from "./ResponsiveImageWithQRCode"
import ResponsiveImageWithQRCodeSmaller from "./ResponsiveImageWithQRCodeSmall"
import Carousel from "react-bootstrap/Carousel"
import chooseTypeNumber from "@/assets/images/chooseType.png"
import chooseTypeName from "@/assets/images/chooseTypeName.png"
import { BsFillPatchCheckFill } from "react-icons/bs"
import Spinner from "react-bootstrap/Spinner"
import invitesmart from "@/assets/images/invitesmart.svg" // Adjust the path as necessary
import { IoMdClose } from "react-icons/io"
import { MdQrCodeScanner } from "react-icons/md"
import { BsDownload } from "react-icons/bs"
import jsPDF from "jspdf"
import "jspdf-autotable"
import "bootstrap/dist/css/bootstrap.min.css" // Ensure Bootstrap is imported
import DownloadSingleImage from "./DownloadSingleImage"
import DownloadSingleImageSmaller from "./DownloadSingleImageSmaller"

import { RgbToHex } from "@/pages/addInvite/displayColor"
export const hexToRgb = (hex: string): string => {
  // Remove the hash if present
  const cleanedHex = hex.replace("#", "")

  // Extract RGB components
  const bigint = parseInt(cleanedHex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return `rgb(${r}, ${g}, ${b})`
}
const findLatestEntitlement = (entitlements: any) => {
  const now = new Date() // Current date and time
  const entitlementList = Object.values(entitlements)
  // Filter entitlements to only include those that have not expired
  const activeEntitlements = entitlementList.filter((entitlement: any) => {
    return new Date(entitlement.expires_date) > now
  })

  console.log("activeEntitlements", activeEntitlements)

  // If no active entitlements, return null or handle appropriately
  if (activeEntitlements.length === 0) return null

  // Find the latest entitlement based on purchase_date
  return activeEntitlements.reduce((latest: any, current: any) => {
    return new Date(current.purchase_date) > new Date(latest.purchase_date)
      ? current
      : latest
  })
}
const ScannedInvitations = () => {
  const { t } = useTranslation()

  const { event_id } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [showPremium, setShowPremium] = useState(true)

  const { isLoading, open_hash, is_open_event } = useAppSelector(
    (state) => state.events,
  )
  const { current_page, total_pages, limit } = useAppSelector(
    (state) => state.contacts,
  )
  const { email, phone, first_name, last_name } = useAppSelector(
    (state) => state?.auth,
  )
  const [loadingPremium, setLoadingPremium] = useState(false)
  const [premium, setPremium] = useState(0)

  const [currentContactId, setCurrentContactId] = useState<any>(null)
  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const event = useAppSelector((state) => state.events.currentEvent)
  const [contacts, setContacts] = useState<any>(null)
  const [qrCodeData, setQrCodeData] = useState<any>(null)

  const [loading, setLoading] = useState(true)
  const [addingGuestLoading, setAddingGuestLoading] = useState(false)
  const [displayImage, setDisplayImage] = useState(false)
  const [currentContact, setCurrentContact] = useState<any>(null)
  const [referesh, setRefresh] = useState(false)
  const [namesInput, setNamesInput] = useState<string>("")
  //edit contact
  const [guestEdit, setGuestEdit] = useState("")
  const [showEditContact, setShowEditContact] = useState(false)
  const [loadingEditGuest, setLoadingEditGuest] = useState(false)

  ///
  const [showDownloadInvites, setShowDownloadInvites] = useState(false)

  const [showDownloadInvitesSingle, setShowDownloadInvitesSingle] =
    useState(false)
  const handleCloseDownloadInvitesSingle = () => {
    setShowDownloadInvitesSingle(false)
  }
  const handleDownLoadSingle = (data: any) => {
    setShowDownloadInvitesSingle(true)
    setCurrentContactSingle([data])
  }
  const [currentContactSingle, setCurrentContactSingle] = useState<any[]>([])

  ///

  const [subscription, setSubscription] = useState("basic_plan")
  const [loadingExport, setLoadingExport] = useState(false)
  ////

  // add guests
  const [addGuestType, setAddGuestType] = useState("")
  const [nextStep, setNextStep] = useState(0)

  //////
  const [isTabActive, setIsTabActive] = useState(true)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setIsTabActive(true) // User returned to the tab
      } else {
        setIsTabActive(false) // User left the tab
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])

  ////control name and number slide
  const [index, setIndex] = useState(0)

  const handleSelect = (selectedIndex: any) => {
    setIndex(selectedIndex)
  }

  ////select
  const images = [chooseTypeName, chooseTypeNumber] // Add more if needed
  const [selectedImage, setSelectedImage] = useState(0)

  /////
  const [numberOfGuests, setNumberOfGuests] = useState<any>(0)
  const [showDeleteContact, setShowDeleteContact] = useState(false)
  const [loadingDeleteContact, setLoadingDeleteContact] = useState(false)
  const [showDeleteEvent, setShowDeleteEvent] = useState(false)
  const [loadingDeleteEvent, setLoadingDeleteEvent] = useState(false)

  const handleCloseDeleteContact = () => {
    setShowDeleteContact(false)
  }
  const handleCloseDeleteEvent = () => {
    setShowDeleteEvent(false)
  }
  const handleDeleteContact = (data: any) => {
    setShowDeleteContact(true)
    setCurrentContact(data)
  }

  const handleDeleteEvent = () => {
    setShowDeleteEvent(true)
  }

  const handleCloseDisplayImage = () => {
    setDisplayImage(false)
  }
  const handleDisplayImage = (data: any) => {
    setDisplayImage(true)
    setCurrentContact(data)
  }
  const handleCloseEditContact = () => {
    setShowEditContact(false)
  }

  const handleEditContact = (data: any) => {
    setCurrentContact(data)
    setGuestEdit(data?.first_name)

    setShowEditContact(true)
  }

  const handleCloseUpdateModal = () => {
    setShowUpdateModal(true)
  }
  const handleCloseCreateModal = () => {
    setShowCreateModal(false)
  }

  const addCard = async () => {
    setShowCreateModal(true)

    console.log("premium", premium)
  }

  useEffect(() => {
    try {
      setLoading(true)
      dispatch(getEvent(Number(event_id))).then(async (res: any) => {
        // qr_code_design_id

        if (res?.payload?.data?.isPremium == 1) {
        }
        try {
          const qrCodeData = await api.events.getQrDesign(
            res?.payload?.data?.qr_code_design_id,
          )
          setQrCodeData(qrCodeData?.data?.data)
        } catch (err) {
          setLoading(false)
        }

        const data = {
          id: Number(event_id),
          currentPage: 1,
          limit: 50,
          searchValue: "",
          statusNumber: "4",
        }
        const contacts = await api.contacts.getContactsOnEventN(data)

        setContacts(contacts?.data?.data)
        setLoading(false)
      })
    } catch {
      setLoading(false)

      toast.error("Error while fetching the event")
    }
  }, [dispatch, event_id, open_hash, is_open_event, referesh])

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const identifier = email || phone || ""
        const res = await api.payments.getPovSubscription(identifier)
        const plan: any = findLatestEntitlement(
          res?.data.subscriber?.entitlements,
        )
        setSubscription(plan?.product_identifier)

        if (
          plan?.product_identifier == "pro_plan" ||
          plan?.product_identifier == "unlimited_plan"
        ) {
          setPremium(1)
        } else {
          // setPremium(0)
        }
      } catch (error) {
        console.error("Error fetching subscription:", error)
      }
    }

    fetchSubscription()
  }, [email, phone])

  const handleSubmitFormNaming = async (e: any) => {
    e.preventDefault()
    try {
      setAddingGuestLoading(true)

      const namesArray = namesInput
        .split(/\s*[,;|\n]\s*/g) // Split by comma, semicolon, or new line, allowing optional spaces
        .map((name) => name.trim())
        .filter((name) => name !== "") // Filter out any empty names
      const formattedNames: any = namesArray.map((name: any) => ({
        first_name: name ? name : "",
        last_name: "",
        suffix: "Mr",
        email: name,
        phone: name,
        quantity_members: "1",
      }))

      const totalData = {
        event_id: event?.event_id,
        contacts: formattedNames,
      }

      const contactAdded: any = await api?.contacts?.addGuest(totalData)

      if (contactAdded?.status == 200) {
        setAddingGuestLoading(false)
        setShowCreateModal(false)

        setRefresh(!referesh)
        toast.success("Guest added  successfully")
        dispatch(getBalance()).then((data) => {
          console.log("data added")
        })
      } else {
        toast.error(
          contactAdded?.data?.message
            ? contactAdded?.data?.message
            : "Guest adding error , try gain later please",
        )
        setShowCreateModal(false)
      }

      // toast.success("Event update successfully")

      // setActivePage("addNames")
    } catch (err: any) {
      setAddingGuestLoading(false)
      setShowCreateModal(false)

      const message = err?.response?.data?.message
        ? err?.response?.data?.message
        : "Error while adding contacts , try gain later please"

      toast.error(message)
      console.log("err", err)
    }
  }
  const handleSubmitFormNumber = async (e: any) => {
    e.preventDefault()

    try {
      setAddingGuestLoading(true)

      const generateRandomPhone = () => {
        const randomPart = Math.floor(100000 + Math.random() * 900000) // Generate a 6-digit number
        return `${randomPart}00` // Append "00" to make it an 8-digit number
      }

      let formattedNames = []

      if (contacts && contacts.length > 0) {
        // Use the last contact as a reference
        const lastContact = contacts[contacts.length - 1]
        const basePhoneNumber = parseInt(
          lastContact.phone.replace(/\D/g, ""),
          10,
        ) // Extract numeric part of phone number

        formattedNames = Array.from({ length: numberOfGuests }, (_, index) => ({
          first_name: `${basePhoneNumber + index + 1}`,
          last_name: lastContact.last_name || "",
          suffix: lastContact.suffix || "Mr",
          email: `${basePhoneNumber + index + 1}`,
          phone: `${basePhoneNumber + index + 1}`, // Increment phone number
          quantity_members: "1",
        }))
      } else {
        // Generate new contacts if no existing contacts
        formattedNames = Array.from({ length: numberOfGuests }, () => ({
          first_name: generateRandomPhone(),
          last_name: "",
          suffix: "Mr",
          email: generateRandomPhone(),
          phone: generateRandomPhone(),
          quantity_members: "1",
        }))
      }

      // Prepare totalData
      const totalData = {
        event_id: event_id,
        contacts: formattedNames,
      }

      // Make API call
      const contactAdded: any = await api?.contacts?.addGuest(totalData)

      if (contactAdded?.status == 200) {
        setShowCreateModal(false)
        setRefresh(!referesh)
        toast.success("Guest added successfully")
        dispatch(getBalance())
      } else {
        setShowCreateModal(false)

        const errorMessage =
          contactAdded?.data?.message ||
          "Error while adding guests, please try again later."
        toast.error(errorMessage)
        setAddingGuestLoading(false)
      }
    } catch (err: any) {
      setShowCreateModal(false)

      const message = err?.response?.data?.message
        ? err?.response?.data?.message
        : "Error while adding contacts , try gain later please"

      setAddingGuestLoading(false)
      toast.error(message)
    } finally {
      setShowCreateModal(false)

      setAddingGuestLoading(false)
    }
  }
  const handleSubmitDeleteEvent = async () => {
    setLoadingDeleteEvent(true)
    try {
      const deleteEvent = await api.events.deleteEvent(
        event?.event_id ? event?.event_id : "",
      )
      if (deleteEvent) {
        setLoadingDeleteEvent(false)
        // setShowDeleteContact(false)
        toast.success("Event deleted successfully")
        setShowDeleteEvent(false)
        setTimeout(() => {
          navigate("/")
        }, 1000)
      } else {
        setShowDeleteEvent(false)
        toast.error("Event Not deleted ")
      }
    } catch (err: any) {
      setLoadingDeleteEvent(false)
      setShowDeleteEvent(false)

      // setShowDeleteContact(false)
      toast.error("Error while deleting card ")
    }
  }

  const handleSubmitDeleteContact = async () => {
    setLoadingDeleteContact(true)
    try {
      // dispatch(
      //   deleteGuest({
      //     eventId: event?.event_id,
      //     guestId: [{ contact_id: currentContact?.id }],
      //   }),
      // ).then((result: any) => {
      //   setLoadingDeleteContact(false)
      //   // setShowDeleteContact(false)
      //   setShowDeleteContact(false)

      //   toast.success("Guest deleted successfully")
      //   setContacts(
      //     contacts.filter((contact: any) => contact.id !== currentContact?.id),
      //   )
      // })

      const params = {
        eventId: event?.event_id,
        contactId: currentContact?.id,
      }
      const deleteGuests = await api.contacts.deleteGuestNew(params)
      if (deleteGuests?.status == 200 || deleteGuests?.status == 202) {
        setLoadingDeleteContact(false)
        // setShowDeleteContact(false)
        setShowDeleteContact(false)

        toast.success("Guest deleted successfully")
        dispatch(getBalance())

        setContacts(
          contacts.filter((contact: any) => contact.id !== currentContact?.id),
        )
      } else {
        setLoadingDeleteContact(false)

        toast.error("Guest not deleted ")
      }
    } catch (err: any) {
      setLoadingDeleteContact(false)
      setShowDeleteContact(false)

      // setShowDeleteContact(false)
      toast.error("Error while deleting event ")
    }
  }

  const handleSubmitEdit = async (e: any) => {
    e.preventDefault()
    setLoadingEditGuest(true)
    try {
      const params = {
        id: currentContact?.id,
        // phone: guestEdit,
        first_name: guestEdit,
      }
      const editContact = await api.contacts.updateContact(params)

      if (editContact?.status == 200) {
        setLoadingEditGuest(false)
        // setShowDeleteContact(false)
        toast.success("Guest edited successfully")
        setShowEditContact(false)
        setRefresh(!referesh)
      } else {
        setShowEditContact(false)
        toast.error("Guest not edited")
      }
    } catch (err: any) {
      setLoadingEditGuest(false)
      setShowEditContact(false)
      const message = err?.response?.data?.message
        ? err?.response?.data?.message
        : "Error while editing guest"

      toast.error(message)
      // setShowDeleteContact(false)
    }
  }
  const handleExportContacts = () => {
    setLoadingExport(true)
    const doc: any = new jsPDF()

    console.log("contacts", contacts)
    doc.autoTable({
      head: [["#", "Guest name or number"]],
      body: contacts.map((contact: any, index: number) => [
        index + 1,
        contact.first_name,
        // contact.email,
        // contact.phone,
      ]),
      styles: { cellPadding: 1.5, fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      alternateRowStyles: { fillColor: [245, 245, 245] },
    })

    // Save the PDF
    doc.save("Scanned_Guests.pdf")
    setLoadingExport(false)
  }

  return (
    <div className="container" style={{ minHeight: "100vh" }}>
      {" "}
      <div className="">
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            {event && (
              <>
                <div className="mb-2 p-0 " style={{ width: "80px" }}>
                  <Button
                    className="d-flex align-items-center "
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      color: "black",
                      fontSize: "18px",
                      textDecoration: "none",
                      textTransform: "none",
                    }}
                    onClick={() => navigate(-1)}
                  >
                    <IconArrowLeft />
                    <span className="reminders-page__link-text me-2">
                      {t("buttons.backNew")}
                    </span>
                  </Button>
                </div>{" "}
                <div className="mt-4 ms-0 ms-md-">
                  <div className="d-flex flex-row gap-0 m-0 p-0  align-items-start justify-content-between ">
                    <div className="m-0 p-0 gap-0">
                      {" "}
                      <h6
                        className="fs-3 fw-bold m-0 p-0"
                        style={{ color: "#000000" }}
                      >
                        {t("invitation.scannedGuests")}
                      </h6>{" "}
                    </div>
                    <div>
                      {contacts?.length > 0 && (
                        <>
                          {" "}
                          {loadingExport ? (
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Spinner animation="border" role="status">
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </Spinner>
                            </div>
                          ) : (
                            <button
                              className="btn btn   d-flex align-items-center "
                              style={{
                                border: "1px solid #20529B",
                                color: "#ffffff",
                                height: "38px",
                                backgroundColor: "#20529B",
                              }}
                              onClick={handleExportContacts}
                            >
                              <BsDownload
                                style={{
                                  color: "#ffffff",
                                  marginRight: "10px",
                                  marginLeft: "10px",
                                }}
                              />
                              {t("inviteDetail.saveAll")}
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>

                  <div
                    className="d-flex mt-5   gap-2 justify-content-start justify-content-md-start "
                    style={{
                      height: "auto",
                      display: "flex",
                      flexWrap: "wrap",

                      // justifyContent: "center",
                    }}
                  >
                    {contacts?.length == 0 && (
                      <>
                        {" "}
                        <div
                          className="d-flex justify-content-center w-100 align-items-center  "
                          style={{ marginTop: "50px" }}
                        >
                          <h5>{t("invitation.noScannedGuestsYet")}</h5>
                        </div>
                      </>
                    )}
                    <div
                      className="d-flex flex-wrap-wrap gap-3"
                      style={{
                        // backgroundColor: "#ffffff",
                        height: "auto",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {contacts?.length > 0 &&
                        contacts?.map((data: any) => (
                          <>
                            <div
                              className="shadow-sm m-0"
                              style={{
                                height: "230px",
                                backgroundColor: "#ffffff",
                                width: "170px",
                                display: "flex",
                                flexDirection: "column",
                                // justifyContent: "center",
                                alignItems: "center",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                                cursor: "pointer",
                              }}
                            >
                              <div
                                style={{
                                  position: "relative", // Position context for the image and edit icon
                                  width: "110px", // Width same as the image size
                                  height: "110px", // Height same as the image size
                                  borderRadius: "50%",
                                  cursor: "pointer",
                                  marginTop: "20px",
                                }}
                              >
                                <img
                                  onClick={() => {
                                    handleDisplayImage(data)
                                  }}
                                  src={qrCodeData?.image_url}
                                  style={{
                                    height: "110px", // Set image height
                                    width: "110px", // Set image width
                                    borderRadius: "50%", // Circular image
                                    display: "block", // Ensures the image is displayed as a block
                                    objectFit: "contain", // Keeps the image's aspect ratio intact
                                    position: "absolute", // Position image inside the div
                                    top: "0", // Position image inside the div
                                    left: "50%", // Center the image horizontally
                                    transform: "translateX(-50%)", // Center the image correctly
                                    backgroundColor: "#c4c4c4",
                                    cursor: "pointer",
                                    // marginTop: "20px"
                                  }}
                                />

                                {/* Edit Icon positioned to overlap half of the image and half below it */}
                                <div
                                  style={{
                                    position: "absolute", // Position it relative to the parent div
                                    bottom: "-20px", // Moves the icon down by half of the icon's height (-15px)
                                    left: "50%", // Center horizontally
                                    transform: "translateX(-50%)", // Center the icon correctly
                                    borderRadius: "50%",
                                    cursor: "pointer",
                                  }}
                                >
                                  {qrCodeData?.guest_type == "name" && (
                                    <div
                                      style={{
                                        textDecoration: "none",
                                        backgroundColor: "#4CB050", // Green background for the edit icon
                                        width: "40px", // Width of the edit icon
                                        height: "40px", // Height of the edit icon
                                        borderRadius: "50%", // Circular edit icon
                                        display: "flex", // Use flexbox to center the icon inside the circle
                                        justifyContent: "center", // Center the icon horizontally
                                        alignItems: "center", // Center the icon vertically
                                        padding: "9px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <MdEdit
                                        style={{ color: "white" }}
                                        onClick={() => handleEditContact(data)}
                                      />{" "}
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="d-flex flex-row  gap-1 mb-0 mt-4">
                                <h5 style={{ fontSize: "1rem" }}>
                                  {data?.first_name}
                                </h5>
                              </div>

                              <div
                                className="mt-2 d-flex flex-row justify-content-between w-100 ps-1 pe-1"
                                // style={{ backgroundColor: "red" }}
                              >
                                <button
                                  onClick={() => {
                                    handleDownLoadSingle(data)
                                  }}
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "#245192",
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "8px 10px",
                                    borderRadius: "10px",
                                    textDecoration: "none",
                                    cursor: "pointer",
                                    fontFamily: "Inter",
                                    border: "none",
                                  }}
                                >
                                  <LuDownload
                                    style={{
                                      fontSize: "20px",
                                      marginRight: "5px",
                                    }}
                                  />
                                </button>

                                <div
                                  style={{
                                    // backgroundColor: "#EE1919",
                                    borderRadius: "50%",
                                    height: "37px",
                                    width: "37px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "9px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <RiDeleteBin6Line
                                    style={{ color: "red" }}
                                    onClick={() => handleDeleteContact(data)}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        ))}
                    </div>
                  </div>
                </div>
              </>
            )}
            {!loading && !event && (
              <div
                className="d-flex flex-column gap-2 align-items-center justify-content-center"
                style={{ height: "40vh" }}
              >
                <div className="alert alert-danger fs-5" role="alert">
                  Event not found with this Id ={event_id}
                </div>
                <Link
                  className="d-flex align-items-center "
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "black",
                    fontSize: "18px",
                    textDecoration: "none",
                    textTransform: "none",
                  }}
                  to="/"
                >
                  <button
                    // onClick={(e) => onSubmit(e, "")}
                    className="btn btn-dark w-100"
                    style={{
                      height: "40px",
                      borderRadius: "5px",
                      backgroundColor: "#20529B",
                      border: "none",
                    }} // Ensure it sticks to the bottom
                  >
                    Back To Home
                  </button>
                </Link>
              </div>
            )}
          </>
        )}
      </div>
      {/* upgrade  */}
      <Modal show={showUpdateModal} onHide={handleCloseUpdateModal} centered>
        <Modal.Header
          closeButton
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "20px",
          }}
        >
          {" "}
        </Modal.Header>

        <Modal.Body
          style={{
            marginTop: "-100px",
            // backgroundColor: "red"
          }}
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5  m-0 w-100"
            style={{
              width: "300px",
              height: "250px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <div className="d-flex flex-column gap-3 ">
              <Button
                className="d-flex mt-3 "
                style={{ backgroundColor: "#20529B", color: "#ffffff" }}
              >
                {" "}
                {t("buttons.upgradeInvitationToPremium")}
              </Button>
              <Button
                className="d-flex "
                style={{ backgroundColor: "#20529B", color: "#ffffff" }}
              >
                {t("buttons.chooseASubscriptionPlan")}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* add guests */}
      <Modal show={showCreateModal} onHide={handleCloseCreateModal} centered>
        <Modal.Body
          style={
            {
              // marginTop: "-100px",
              // backgroundColor: "blue",
            }
          }
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5 pb-2   m-0 w-100 "
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
              // backgroundColor: "green",
              // padding: "0px",
            }}
          >
            {contacts?.length > 0 ? (
              <>
                {qrCodeData?.guest_type == "name" ? (
                  <div>
                    <form
                      className="d-flex flex-column p-3"
                      onSubmit={handleSubmitFormNaming}
                    >
                      <div className=" d-flex justify-content-center">
                        <h5 className="mb-1 fs-3 fw-bold">
                          {/* {t("invitation.addNames")} */}
                          {/* Add Names */}
                          {t("inviteDetail.addNames")}
                        </h5>{" "}
                      </div>
                      <div className="d-flex flex-column justify-content-center align-items-center mt-2 mb-2 ">
                        <h5
                          style={{
                            position: "relative",
                            paddingBottom: "8px", // Adjust for spacing between text and underline
                          }}
                          className="mb-2 pb-2 "
                        >
                          <span className="me-1">{t("invitation.please")}</span>
                          <span className="me-1" style={{ color: "#20529B" }}>
                            {t("invitation.add")}
                          </span>
                          <span className="me-1">
                            {" "}
                            {t("invitation.nameOr")}
                          </span>
                          <span style={{ color: "#20529B" }} className="me-1">
                            {t("invitation.paste")}
                          </span>
                          {t(
                            "invitation.themHereSeparateEachGuestNameWithAComma",
                          )}
                        </h5>
                        <div
                          className="profile-input mt-2 rounded-sm text-dark d-flex -justify-content-center "
                          style={{ width: "85%" }}
                        >
                          <style>
                            {`
         input::placeholder {
        color: #d3d2d2;
          
               }
             `}
                          </style>
                          <textarea
                            required
                            placeholder={t("invitation.addGuestName")}
                            value={namesInput}
                            onChange={(e) => setNamesInput(e.target.value)}
                            style={{
                              color: "#000000", // Text color
                              fontSize: "1rem",
                              paddingLeft: "20px",
                              paddingRight: "10px",
                              backgroundColor: "white",
                              borderRadius: "10px",
                              paddingTop: "20px",
                              paddingBottom: "7px",
                              border: "1px solid #ccc", // Optional: border styling
                              width: "100%",
                              resize: "vertical",
                              //   height: "100px", // Adjust height as needed
                            }}
                            rows={5} // Optional: Controls the default number of rows
                          />
                        </div>
                      </div>
                      <button
                        type="submit"
                        // onClick={(e) => onSubmit(e, "")}
                        className="w-100 btn btn-dark d-flex align-items-center justify-content-center"
                        style={{
                          width: "150px",
                          height: "40px",
                          borderRadius: "5px",
                          backgroundColor: "#20529B",
                          border: "none",
                          // marginLeft: "auto",
                          marginTop: "20px",
                        }} // Ensure it sticks to the bottom
                        disabled={addingGuestLoading}
                      >
                        {addingGuestLoading ? (
                          <h6 className="pt-1">Loading...</h6>
                        ) : (
                          t("buttons.addGuests")
                        )}
                      </button>
                    </form>
                  </div>
                ) : (
                  <div>
                    <form
                      className="d-flex flex-column gap-4 align-items-center justify-content-center"
                      onSubmit={handleSubmitFormNumber}
                    >
                      <h5 className=" fs-3 fw-bold">
                        {t("inviteDetail.addGuests")}
                      </h5>{" "}
                      <h5
                        style={{
                          position: "relative",
                          paddingBottom: "8px", // Adjust for spacing between text and underline
                        }}
                      >
                        {t("inviteDetail.howManyGuestsYouWantToAdd")}
                      </h5>
                      <input
                        type="number"
                        value={numberOfGuests}
                        onChange={(e: any) =>
                          setNumberOfGuests(Math.max(1, Number(e.target.value)))
                        }
                        className="form-control"
                        min={1}
                        style={{ width: "230px" }}
                        placeholder="Number of Guests"
                      />{" "}
                      <button
                        type="submit"
                        // onClick={(e) => onSubmit(e, "")}
                        className="btn btn-dark w-100"
                        style={{
                          height: "40px",
                          borderRadius: "5px",
                          backgroundColor: "#20529B",
                          border: "none",
                        }} // Ensure it sticks to the bottom
                        disabled={addingGuestLoading}
                      >
                        {addingGuestLoading ? (
                          <h6 className="p-1">loading...</h6>
                        ) : (
                          t("buttons.addGuests")
                        )}
                      </button>
                    </form>
                  </div>
                )}
              </>
            ) : (
              <>
                {nextStep == 0 && (
                  <div className="mt-4 p-0">
                    <h6
                      style={{
                        fontSize: "15px",
                        color: "#000000",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "20px",
                      }}
                    >
                      {t("inviteDetail.chooseType")}
                    </h6>

                    <div
                      style={{
                        margin: "0px",
                        // backgroundColor: "red",
                        width: "100%", // Ensure it takes full width for centering
                        height: "400px",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column", // Center vertically within the container
                        padding: "0px",
                      }}
                    >
                      <div
                        style={{
                          width: "250px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "400px",
                          // backgroundColor: "yellow",
                          gap: "10px",
                        }}
                      >
                        <Carousel
                          activeIndex={index}
                          onSelect={handleSelect}
                          touch={true}
                          interval={null}
                          indicators={false}
                        >
                          <Carousel.Item>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column", // Stack vertically
                                alignItems: "flex-start", // Align text to the left
                                position: "relative",
                              }}
                            >
                              <h6
                                style={{
                                  marginBottom: "10px",
                                  color: "#20529B",
                                  display: "flex",
                                }}
                              >
                                {" "}
                                {/* Add spacing */}
                                {t("inviteDetail.names")}
                              </h6>
                              <img
                                src={chooseTypeName}
                                alt="Option 1"
                                style={{
                                  height: "270px",
                                  width: "250px",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </Carousel.Item>
                          <Carousel.Item>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column", // Stack vertically
                                alignItems: "flex-start", // Align text to the left
                                position: "relative",
                              }}
                            >
                              <h6
                                style={{
                                  marginBottom: "10px",
                                  color: "#20529B",
                                }}
                              >
                                {" "}
                                {/* Add spacing */}
                                {t("inviteDetail.numbers")}
                              </h6>
                              <img
                                src={chooseTypeNumber}
                                alt="Option 1"
                                style={{
                                  height: "270px",
                                  width: "250px",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </Carousel.Item>
                        </Carousel>

                        {/* Custom Progress Indicator (Dots) */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "10px",
                            gap: "10px", // Add spacing between dots
                            marginBottom: "10px",
                          }}
                        >
                          {[0, 1].map((_, i) => (
                            <div
                              key={i}
                              onClick={() => handleSelect(i)}
                              style={{
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                                backgroundColor:
                                  index === i ? "#20529B" : "#ccc",
                                cursor: "pointer",
                              }}
                            />
                          ))}
                        </div>
                        <button
                          className="btn btn-dark mt-2"
                          style={{
                            width: "100%",
                            borderRadius: "5px",
                            backgroundColor: "#20529B",
                            border: "none",
                            paddingLeft: "5px",
                            paddingRight: "5px",
                            bottom: "0px",
                            color: "#ffffff",
                          }}
                          onClick={() => setNextStep(1)}
                        >
                          {t("inviteDetail.next")}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {nextStep == 1 && (
                  <>
                    {index == 0 ? (
                      <div>
                        <Button
                          className="mt-2 d-flex align-items-center "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            color: "black",
                            fontSize: "18px",
                            textDecoration: "none",
                            textTransform: "none",
                          }}
                          onClick={() => setNextStep(0)}
                        >
                          <IconArrowLeft />
                          <span className="reminders-page__link-text">
                            {t("buttons.backNew")}
                          </span>
                        </Button>
                        <form
                          className="d-flex flex-column p-3"
                          onSubmit={handleSubmitFormNaming}
                        >
                          <div className=" d-flex justify-content-center">
                            <h5 className="mb-1 fs-3 fw-bold">
                              {/* {t("invitation.addNames")} */}
                              {/* Add Names */}
                              {t("inviteDetail.addNames")}
                            </h5>{" "}
                          </div>
                          <div className="d-flex flex-column justify-content-center align-items-center mt-2 mb-2 ">
                            <h5
                              style={{
                                position: "relative",
                                paddingBottom: "8px", // Adjust for spacing between text and underline
                              }}
                              className="mb-2 pb-2 "
                            >
                              <span className="me-1">
                                {t("invitation.please")}
                              </span>
                              <span
                                className="me-1"
                                style={{ color: "#20529B" }}
                              >
                                {t("invitation.add")}
                              </span>
                              <span className="me-1">
                                {" "}
                                {t("invitation.nameOr")}
                              </span>
                              <span
                                style={{ color: "#20529B" }}
                                className="me-1"
                              >
                                {t("invitation.paste")}
                              </span>
                              {t(
                                "invitation.themHereSeparateEachGuestNameWithAComma",
                              )}
                            </h5>
                            <div
                              className="profile-input mt-2 rounded-sm text-dark d-flex -justify-content-center "
                              style={{ width: "85%" }}
                            >
                              <style>
                                {`
      input::placeholder {
        color: #d3d2d2;
        
      }
    `}
                              </style>
                              <textarea
                                required
                                placeholder={t("invitation.addGuestName")}
                                value={namesInput}
                                onChange={(e) => setNamesInput(e.target.value)}
                                style={{
                                  color: "#000000", // Text color
                                  fontSize: "1rem",
                                  paddingLeft: "20px",
                                  paddingRight: "10px",
                                  backgroundColor: "white",
                                  borderRadius: "10px",
                                  paddingTop: "20px",
                                  paddingBottom: "7px",
                                  border: "1px solid #ccc", // Optional: border styling
                                  width: "100%",
                                  resize: "vertical",
                                  //   height: "100px", // Adjust height as needed
                                }}
                                rows={5} // Optional: Controls the default number of rows
                              />
                            </div>
                          </div>
                          <button
                            type="submit"
                            // onClick={(e) => onSubmit(e, "")}
                            className="btn btn-dark"
                            style={{
                              width: "150px",
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "#20529B",
                              border: "none",
                              marginLeft: "auto",
                              marginTop: "20px",
                            }} // Ensure it sticks to the bottom
                            disabled={addingGuestLoading}
                          >
                            {addingGuestLoading ? (
                              <h6 className="pt-1">Loading...</h6>
                            ) : (
                              t("buttons.addGuests")
                            )}
                          </button>
                        </form>
                      </div>
                    ) : (
                      <div>
                        <Button
                          className="d-flex align-items-center "
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            color: "black",
                            fontSize: "18px",
                            textDecoration: "none",
                            textTransform: "none",
                          }}
                          onClick={() => setNextStep(0)}
                        >
                          <IconArrowLeft />
                          <span className="reminders-page__link-text">
                            {t("buttons.backNew")}
                          </span>
                        </Button>
                        <form
                          className="d-flex flex-column gap-4 align-items-center justify-content-center"
                          onSubmit={handleSubmitFormNumber}
                        >
                          <h5 className=" fs-3 fw-bold">
                            {t("inviteDetail.addGuests")}
                          </h5>{" "}
                          <h5
                            style={{
                              position: "relative",
                              paddingBottom: "8px", // Adjust for spacing between text and underline
                            }}
                          >
                            {t("inviteDetail.howManyGuestsYouWantToAdd")}
                          </h5>
                          <input
                            type="number"
                            value={numberOfGuests}
                            onChange={(e: any) =>
                              setNumberOfGuests(
                                Math.max(1, Number(e.target.value)),
                              )
                            }
                            className="form-control"
                            min={1}
                            style={{ width: "230px" }}
                            placeholder="Number of Guests"
                          />{" "}
                          <button
                            type="submit"
                            // onClick={(e) => onSubmit(e, "")}
                            className="btn btn-dark w-100"
                            style={{
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "#20529B",
                              border: "none",
                            }} // Ensure it sticks to the bottom
                            disabled={addingGuestLoading}
                          >
                            {addingGuestLoading ? (
                              <h6 className="p-1">loading...</h6>
                            ) : (
                              t("buttons.addGuests")
                            )}
                          </button>
                        </form>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
      {/* display image */}
      <Modal
        show={displayImage}
        onHide={handleCloseDisplayImage}
        centered

        // style={{ all: "unset" }} // Disable all inherited styles for the modal itself
      >
        {/* <Modal.Header className="d-flex fled-row justifyContent">
          {" "}
        </Modal.Header> */}
        <Modal.Body className=" ms-0 me-0  mt-1 mb-1 w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0">
          <div
            className="m-0 p-0 "
            // style={{ minHeight: "300px", }}
          >
            <div className="w-100 d-none d-sm-block ">
              <ResponsiveImageWithQRCode
                currentContact={currentContact}
                event={event}
                qrCodeData={qrCodeData}
                setDisplayImage={setDisplayImage}
              />
            </div>
            <div className="w-100 d-block d-sm-none">
              <ResponsiveImageWithQRCodeSmaller
                currentContact={currentContact}
                event={event}
                qrCodeData={qrCodeData}
                setDisplayImage={setDisplayImage}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* donwload single  */}
      <Modal
        show={showDownloadInvitesSingle}
        onHide={handleCloseDownloadInvitesSingle}
        centered
      >
        <Modal.Body
          style={
            {
              // marginTop: "-100px",
              // backgroundColor: "red"
            }
          }
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5 pb-2  pt-3 pb-3  m-0 "
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            <div className="w-100 d-none d-sm-block ">
              <DownloadSingleImage
                // ref={downloadRef}

                nameOrNumberArray={
                  currentContactSingle ? currentContactSingle : []
                } // Example numbers
                event={event}
                setShowDownloadInvites={setShowDownloadInvites}
                qrCodeData={qrCodeData}
              />
            </div>
            <div className="w-100 d-block d-sm-none ">
              <DownloadSingleImageSmaller
                // ref={downloadRef}
                nameOrNumberArray={
                  currentContactSingle ? currentContactSingle : []
                } // Example numbers
                event={event}
                setShowDownloadInvites={setShowDownloadInvites}
                qrCodeData={qrCodeData}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* edit contant  */}
      <Modal show={showEditContact} onHide={handleCloseEditContact} centered>
        <Modal.Body
          style={{
            marginTop: "-100px",
            // backgroundColor: "red"
          }}
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5 pb-2   m-0 w-100"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            <div>
              <form
                className="d-flex flex-column gap-4 align-items-center justify-content-center"
                onSubmit={handleSubmitEdit}
              >
                <h5 className=" fs-3 fw-bold">{t("inviteDetail.editGuest")}</h5>{" "}
                <input
                  type="text"
                  value={guestEdit}
                  // onChange={(e: any) => setGuestEdit(e.target.value)}
                  onChange={(e: any) => {
                    const value = e.target.value
                    // Allow only letters (uppercase and lowercase) and spaces
                    const textOnly = value.replace(/[^a-zA-Z\s]/g, "")
                    setGuestEdit(textOnly)
                  }}
                  // min={1}
                  className="form-control"
                  style={{ width: "300px" }}
                  placeholder="Edit  of Guests"
                />{" "}
                <div className="d-flex justify-content-space-between gap-3 mt-3 ">
                  <button
                    // onClick={(e) => onSubmit(e, "")}
                    type="button" // Prevent form submission
                    className="btn btn-dark  "
                    style={{
                      width: "130px",
                      height: "40px",
                      borderRadius: "5px",
                      backgroundColor: "white",
                      border: "1ps solid grey",
                      color: "black",
                    }} // Ensure it sticks to the bottom
                    onClick={handleCloseEditContact}
                  >
                    {t("buttons.cancel")}
                  </button>
                  <button
                    type="submit"
                    // onClick={(e) => onSubmit(e, "")}
                    className="btn btn-dark "
                    style={{
                      width: "130px",
                      height: "40px",
                      borderRadius: "5px",
                      backgroundColor: "#20529B",
                      border: "none",
                    }} // Ensure it sticks to the bottom
                    disabled={loadingEditGuest}
                  >
                    {loadingEditGuest ? (
                      <h6 className="mt-1">editing...</h6>
                    ) : (
                      t("inviteDetail.editGuest")
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* delete and contact */}
      <Modal
        show={showDeleteContact}
        onHide={handleCloseDeleteContact}
        centered
      >
        <Modal.Body
          style={{
            marginTop: "-100px",
            // backgroundColor: "red"
          }}
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5 pb-2   m-0 w-100"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            <div className="d-flex flex-column gap-4 align-items-center justify-content-center">
              {/* <form
                className="d-flex flex-column gap-4 align-items-center justify-content-center"
                onSubmit={handleSubmitDeleteContact}
              > */}
              <h5 className=" fs-3 fw-bold">{t("inviteDetail.areYouSure")}</h5>{" "}
              <h5
                className="d-flex flex-wrap"
                style={{
                  position: "relative",
                  paddingBottom: "8px", // Adjust for spacing between text and underline
                }}
              >
                {t("inviteDetail.deleteGuestInfo")}
              </h5>
              <div className="d-flex justify-content-space-between gap-4 ">
                <button
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark w-100 "
                  style={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    border: "1ps solid grey",
                    color: "black",
                  }} // Ensure it sticks to the bottom
                  onClick={handleCloseDeleteContact}
                >
                  {t("buttons.cancel")}
                </button>
                <button
                  type="submit"
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark  w-100"
                  style={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#20529B",
                    border: "none",
                  }} // Ensure it sticks to the bottom
                  disabled={loadingDeleteContact}
                  onClick={handleSubmitDeleteContact}
                >
                  {loadingDeleteContact ? (
                    <h6 className="mt-1">deleting ...</h6>
                  ) : (
                    t("buttons.delete")
                  )}
                </button>
              </div>
              {/* </form> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* delete devent/ */}
      <Modal show={showDeleteEvent} onHide={handleCloseDeleteEvent} centered>
        <Modal.Body
          style={{
            marginTop: "-100px",
            // backgroundColor: "red"
          }}
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5 pb-2   m-0 w-100"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            <div className="d-flex flex-column gap-4 align-items-center justify-content-center">
              {/* <form
                className="d-flex flex-column gap-4 align-items-center justify-content-center"
                onSubmit={handleSubmitDeleteContact}
              > */}
              <h5 className=" fs-3 fw-bold">
                {/* {t("invitation.addNames")} */}
                {t("inviteDetail.areYouSure")}
              </h5>{" "}
              <h5
                style={{
                  position: "relative",
                  paddingBottom: "8px", // Adjust for spacing between text and underline
                }}
              >
                {t("inviteDetail.youAreAboutToDeleteAnInvite")}
              </h5>
              <div className="d-flex justify-content-space-between gap-4 ">
                <button
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark w-100 "
                  style={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    border: "1ps solid grey",
                    color: "black",
                  }} // Ensure it sticks to the bottom
                  onClick={handleCloseDeleteEvent}
                >
                  {t("buttons.cancel")}
                </button>
                <button
                  type="submit"
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark  w-100"
                  style={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#20529B",
                    border: "none",
                  }} // Ensure it sticks to the bottom
                  disabled={loadingDeleteEvent}
                  onClick={handleSubmitDeleteEvent}
                >
                  {loadingDeleteEvent ? (
                    <h6 className="mt-1">deleting ...</h6>
                  ) : (
                    t("buttons.delete")
                  )}
                </button>
              </div>
              {/* </form> */}
            </div>
          </div>
          {/* <ToastContainer
            style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
          /> */}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ScannedInvitations
